import { useEffect, useState } from 'react'

export const BROADCAST_MESSAGES = {
	USER_CLOSE_ONBOARDING_MODAL: 'user-close-onboarding-modal',
}

export type typeBroadcastMessage =
	(typeof BROADCAST_MESSAGES)[keyof typeof BROADCAST_MESSAGES]

export const useBroadcastChannel = (
	channelName: typeBroadcastMessage
): {
	message: typeBroadcastMessage | undefined
	postMessage: (msg: typeBroadcastMessage) => void
} => {
	const [message, setMessage] = useState<typeBroadcastMessage>()
	const [broadcastChannel, setBroadcastChannel] = useState<BroadcastChannel>()

	useEffect(() => {
		// Browser Support https://caniuse.com/broadcastchannel
		if (typeof BroadcastChannel === 'undefined') {
			console.warn('BroadcastChannel is not supported in this browser.')
			return
		}

		const channel = new BroadcastChannel(channelName)
		setBroadcastChannel(channel)

		const handleMessage = (event: MessageEvent): void => {
			setMessage(event.data)
		}

		channel.addEventListener('message', handleMessage)
	}, [channelName])

	const postMessage = (msg: typeBroadcastMessage): void => {
		if (broadcastChannel !== undefined) {
			broadcastChannel.postMessage(msg)
		} else {
			console.warn('BroadcastChannel is not available.')
		}
	}

	return { message, postMessage }
}
